<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader></MoonLoader>
    </div>
    <div v-else>
      <div v-if="answers.length > 0" class="row">
        <div class="col-md-6 col-xl-3" v-for="answer in answers" :key="answer.id">
          <DashboardElementPrimary :answer="answer" :company="company" :doubleSide="false"></DashboardElementPrimary>
        </div>
      </div>
      <div v-else class="row text-center">
        <div class="col">
          <h4>First you need to answer some questions of Sign up questionnaire for Category:</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardElementPrimary from '@/components/Dashboard/DashboardElementPrimary';
import PublicCategoryDashboardElementController from '@/controllers/PublicData/PublicCategoryDashboardElementController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
export default {
  name: 'PublicCategoryPage',
  components: { MoonLoader, DashboardElementPrimary },
  props: {
    company: Object,
    category: Object,
  },
  data() {
    return {
      loading: false,
      answers: null,
    };
  },

  watch: {
    async category() {
      this.loading = true;
      await this.getCategoryDashboardElements();
      this.loading = false;
    },
  },
  async created() {
    this.loading = true;
    await this.getCategoryDashboardElements();
    this.loading = false;
  },
  methods: {
    async getCategoryDashboardElements() {
      this.answers = await PublicCategoryDashboardElementController.show(this.category.id);
    },
  },
};
</script>

<style scoped></style>
